var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyeClosed = function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 26,
    height: 14,
    viewBox: "0 0 0.91 0.5",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.09.1c.09.13.3.36.48.3C.64.38.78.16.82.09",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.18,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })));
};

export default SvgEyeClosed;